import { render, staticRenderFns } from "./TestimonialsEdit.vue?vue&type=template&id=33842cb8&"
import script from "./TestimonialsEdit.vue?vue&type=script&lang=js&"
export * from "./TestimonialsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports